"use client";
import React, { useRef, useEffect } from "react";
import "../Styles/Aboutpr.css";
import { Heropar } from "../Components/Heropar";
import LightRays from "./LightRays";   

import img1 from "../Assets/bg13.jpg";
import img2 from "../Assets/bg14.jpg";
import img3 from "../Assets/bg15.jpg";
import img4 from "../Assets/award3.png";
import img5 from "../Assets/award2.png";
import img6 from "../Assets/bg16.jpg";
import img7 from "../Assets/bg17.jpg";
import img8 from "../Assets/bg18.jpg";
import Parallax from "./Parallax";
import Services from "./Services";
import img10 from "../Assets/bg5.jpg";

const products = [
  { thumbnail: img1 },
  { thumbnail: img2 },
  { thumbnail: img3 },
  { thumbnail: img4 },
  { thumbnail: img5 },
  { thumbnail: img6 },
  { thumbnail: img7 },
  { thumbnail: img8 },
];

const Aboutpr = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const form = useRef();

  return (
    <>
      <div className="aboutpr-container">
      <div className="silk-bg">
        <div style={{ width: "100%", height: "600px", position: "relative" }}>
          <LightRays
            raysOrigin="top-center"
            raysColor="#ffffffff"
            raysSpeed={2.5}
            lightSpread={2}
            rayLength={5}
            followMouse={true}
            mouseInfluence={0.1}
            noiseAmount={0.1}
            distortion={0.05}
            className="custom-rays"
          />
        </div>
      </div>

      <Heropar
        products={products}
        heading="About Us"
        description="At DD Digital Construction, we pride ourselves on being the best digital marketing company in Tamil Nadu, helping businesses build a powerful online presence and achieve measurable growth. With expertise in SEO, social media marketing, content strategy, branding, and performance-driven campaigns, we craft customized solutions tailored to your industry and audience."
      />
    </div>
      <Services />
      <Parallax
        background={img10}
        heading="Turning Clicks into Customers"
        description="As the best digital marketing company, we don’t just focus on traffic — we focus on results. With data-driven strategies, creative campaigns, and advanced analytics, we help brands maximize ROI, boost visibility, and convert audiences into loyal customers. Our mission is simple: deliver measurable growth that speaks for itself."
      />
    </>
  
    
  );

};

export default Aboutpr;
